<template>
  <div class="contact-info">
    <div class="slogan">
      <h3>有需求？直接與我們聯繫</h3>
    </div>
    <div class="contact-columns">
      <div class="contact-column">
        <h4>停車場大小事</h4>
        <p class="line" @click="openLineQRPage">
          <!-- <img src="/path-to-line-icon.png" alt="LINE" class="line-icon"> -->
          <img src="https://upload.wikimedia.org/wikipedia/commons/4/41/LINE_logo.svg" alt="LINE" class="line-icon">
          @TWPK
        </p>
      </div>
      <div class="custom-border"></div>
      <div class="contact-column  with-border">
        <h4>聯絡我們</h4>
        <p class="address">台北市民生東路一段51號9樓</p>
        <p class="email" @click="openEmail">service@taiwan-parking.com.tw</p>
        <p class="line" @click="openLineQRPage">
          <!-- <img src="/path-to-line-icon.png" alt="LINE" class="line-icon"> -->
          <img src="https://upload.wikimedia.org/wikipedia/commons/4/41/LINE_logo.svg" alt="LINE" class="line-icon">
          @TWPK
        </p>
      </div>
      <!-- <div class="custom-border"></div>
      <div class="contact-column  with-border">
        <h4>其他事項</h4>
        <p class="line" @click="openLineQRPage">
          <img src="https://upload.wikimedia.org/wikipedia/commons/4/41/LINE_logo.svg" alt="LINE" class="line-icon">
          @TWPK
        </p>
      </div> -->
    </div>
  </div>
  <div class="footer-links">
    <!-- <img src="/path-to-company-logo.png" alt="Company Logo" class="company-logo"> -->
    <div class="ft-nav">
      <a href="/">

        <img src="../../public/logo.png" alt="Company Logo" class="company-logo">
      </a>
      <nav>
        <a href="/about">公司簡介</a>
        <a href="/parking-lots">停車場位置</a>
        <a href="/collaboration-page">委託與合作</a>
        <a href="/qna">常見Q&A</a>
        <a href="#">隱私權政策</a>
      </nav>
    </div>
    <p class="copyright">Copyright © 2024 TaipeiParking.com</p>
  </div>

</template>

<script>
export default {
  name: 'ContactFooter',

  methods: {
    openLineQRPage() {
      window.open('https://line.me/R/ti/p/@394lotqi?ts=12051457&oat_content=url', '_blank');
    },
    openEmail() {
      window.open('mailto:service@taiwan-parking.com.tw', '_blank');
    }
  }
}
</script>

<style scoped>
.contact-info {
  display: flex;
  flex-direction: column;

  background-color: var(--bg-darkgray0);
  padding: 0 0;
  /* align-items: center ; */
  height: 548px;
  color: white;

  font-weight: 700;

  width: 100%;

}


.slogan h3 {

  /* //styleName: 5xl/bold; */
  font-family: Inter;
  font-size: 40px;
  font-weight: 700;
  line-height: 53.6px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;


  margin-top: 80px;
  margin-bottom: 86px;
}


.with-border {
  /* border-left: 1px solid #ddd; */
  border: 0px;
  /* Add vertical split line */
  /* padding-left: 20px; */
  /* Add padding to avoid text touching the border */
}


.contact-columns {
  position:relative;

  display: flex;
  /* justify-content: space-around; */
  justify-content: center;
  width: 85%;
  min-width: 903px;
  flex-wrap: wrap;
  margin: 0 auto;
  padding: 0 0;
}


.custom-border {
  /* position: absolute; */
  left: 0;
  margin-top: 20px;
  /* Adjust to set the starting point of the border */
  height: 188px;
  /* Adjust to set the length of the border */
  border-left: 1px solid #777;

  margin-left: 40px;
  margin-right: 80px;
}

.contact-column {
  /* width:80%; */

  text-align: center;
  /* margin-bottom: 20px; */
  /* padding: 4rem 10rem; */
  padding: 0 0;
  width: 40%;
  min-width: 300px;
}


h4 {
  /* //styleName: 2xl/bold; */
  font-family: Inter;
  font-size: 32px;
  font-weight: 700;
  line-height: 33.6px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  margin-top: 0px;
  /* margin-bottom: 3rem; */
}

.phone {
  /* //styleName: 5xl/bold; */
  font-family: Inter;
  font-size: 40px;
  font-weight: 700;
  line-height: 53.6px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;


  color: var(--yellow03);
  /* margin: 10px 0; */
  margin-top: 50px;
  margin-bottom: 0px;
}

.address {
  /* //styleName: 5xl/bold; */
  /* position: absolute; */
  /* top:100px;left: 0; */

  font-family: Inter;
  /* font-size: 28px; */
  /* font-weight: 700; */
  /* line-height: 53.6px; */
  text-align: center;
  /* text-underline-position: from-font; */
  /* text-decoration-skip-ink: none; */
  margin-top:-23px;
  margin-bottom: -45px;
}


.email {
  /* //styleName: 5xl/bold; */
  font-family: Inter;
  font-size: 28px;
  font-weight: 700;
  line-height: 53.6px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;


  color: var(--yellow03);
  /* margin: 10px 0; */
  margin-top: 50px;
  margin-bottom: 0px;
}


.line {
  margin-top: 12px;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0px;

  font-family: Inter;
  font-size: 24px;
  font-weight: 700;
  line-height: 29.05px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  cursor: pointer;

}


.line :hover {
  cursor: pointer;
  /* add animation effect , font enlarge */
  font-size: 26px;
  transition:  transform 0.2s;

  transform: scale(1.1);
}

.line-icon {
  width: 40px;
  height: 40px;
  margin-right: 6px;
}

.footer-links {
  /* display: flex; */
  display: none;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  /* background-color: #008000; */
  padding: 20px 0;
  text-align: center;
}

.company-logo {
  width: 4rem;
  margin-bottom: 20px;
  margin-right: 1rem;
}

.ft-nav {
  margin-top: 10px;
  margin-left: 5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
}

nav {
  margin-bottom: 20px;
}

nav a {
  color: white;
  text-decoration: none;
  margin: 0 10px;
}

.copyright {
  font-size: 1rem;
  margin-right: 4rem;
}




@media (max-width: 560px) {

  .contact-info {
    height: 774px;
    /* height: 744px; */
  }

  .slogan h3 {
    font-size: 24px;
    margin-top: 40px;
    margin-bottom: 40px;
  }

  .contact-columns {
    width: 100%;
    min-width: 0;

    /* height:648px; */

    flex-direction: column;
    align-items: center;
  }

  .custom-border {
    /* position: absolute; */
    left: 0;
    margin-top: 0px;
    /* Adjust to set the starting point of the border */
    height: 0.5px;
    width: 250px;
    /* Adjust to set the length of the border */
    border-top: 1px solid #777;
    border-left: none;
  }



  .with-border {
    border-left: none;
    /* border-top: 1px solid #ddd; */
    padding-top: 32px;
    /* padding-bottom: 32px; */
  }


  h4 {
    font-size: 20px;
    margin-top: 0px;
    /* margin-bottom: 3rem; */
  }

  .address {

    /* font-size: 28px; */
    font-size: 14px;
    /* font-weight: 700; */
    /* line-height: 53.6px; */
    text-align: center;
    /* text-underline-position: from-font; */
    /* text-decoration-skip-ink: none; */
    margin-top: -15px;
    margin-bottom: -40px;
  }

  .phone {
    /* font-size: 32px; */
    font-size: 32px;
    color: var(--yellow03);
    /* margin: 10px 0; */
    margin-top: 32px;
    margin-bottom: 0px;
  }

  .email {

    /* font-size: 28px; */
    font-size: 30px;
    /* font-weight: 700; */
    /* line-height: 53.6px; */
    line-height: 40px;
    text-align: center;
    /* text-underline-position: from-font; */
    /* text-decoration-skip-ink: none; */
    /* margin-top: 32px; */
    /* margin-bottom: 0px; */
  }

  .line {
    margin-top: 6px;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 32px;
  }

  .line-icon {
    width: 40px;
    height: 40px;
    margin-right: 5px;
    border-radius: 8px;
  }

}
</style>
